/**
 * Modal — диалог подтверждения. На телефоне — bottom-sheet, на широком экране — карточка по центру.
 */
import type { ReactNode } from "react";

type Props = {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
};

export function Modal({
  open,
  title,
  children,
  confirmText = "Подтвердить",
  cancelText = "Отмена",
  onConfirm,
  onCancel,
  loading = false,
}: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/60" onClick={loading ? undefined : onCancel} />
      <div className="relative z-10 w-full rounded-t-3xl border border-white/[0.06] bg-surface-card p-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] text-white sm:max-w-sm sm:rounded-3xl">
        <h2 className="text-[18px] font-semibold">{title}</h2>
        <div className="mt-2 text-[15px] leading-snug text-white/55">{children}</div>
        <div className="mt-5 flex gap-3">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 rounded-2xl border border-white/10 px-4 py-3 text-[15px] active:bg-white/5 disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 rounded-2xl bg-brand px-4 py-3 text-[15px] font-semibold text-surface-base active:brightness-95 disabled:opacity-50"
          >
            {loading ? "…" : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}